import { render, staticRenderFns } from "./FinalVideo.vue?vue&type=template&id=4f66aacd&scoped=true"
import script from "./FinalVideo.vue?vue&type=script&lang=js"
export * from "./FinalVideo.vue?vue&type=script&lang=js"
import style0 from "./FinalVideo.vue?vue&type=style&index=0&id=4f66aacd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f66aacd",
  null
  
)

export default component.exports